// src/i18n/locales/de/vip.ts
// All user-facing VIP/upgrade strings — German

const vip = {
  // -------------------------------------------------------------------------
  // Sidebar (DashboardLayout)
  // -------------------------------------------------------------------------
  sidebar: {
    chatLocked: 'NutriBot (VIP)',
    chatLockedHint: 'Upgrade für KI-Coaching freischalten',
  },

  // -------------------------------------------------------------------------
  // ChatBot upgrade elements (ChatBot.tsx)
  // -------------------------------------------------------------------------
  chatBot: {
    lockedStatus: 'Nur für VIP',
    upgradeTitle: 'NutriBot-Coaching freischalten',
    upgradeDescription:
      'Erhalte rund um die Uhr Zugang zu deinem persönlichen KI-Ernährungscoach \u2014 personalisierte Pläne, Echtzeitanpassungen und professionelle Beratung.',
    bullet1: 'Unbegrenzte Plananpassungen jederzeit',
    bullet2: 'Mahlzeiten in Echtzeit anpassen & tauschen',
    bullet3: 'Proaktives Coaching & motivierende Begleitung',
    upgradeCta: 'Auf VIP upgraden',
    inputPlaceholder: 'NutriBot ist nur f\u00fcr VIP-Mitglieder verf\u00fcgbar',
  },

  // -------------------------------------------------------------------------
  // Upgrade modal (UpgradeModal.tsx)
  // -------------------------------------------------------------------------
  upgradeModal: {
    priceFrom: 'Ab',
    perMonth: ' / Monat',
    cta: 'Auf VIP upgraden',

    shoppingList: {
      title: 'Einkaufsliste nur f\u00fcr VIP',
      description:
        'Deine smarte, automatisch generierte Einkaufsliste ist eine VIP-Funktion. Upgrade jetzt, um eine vollst\u00e4ndig synchronisierte Liste auf Zutatenbasis zu erhalten.',
      bullet1: 'Automatisch aus deinem aktiven Ern\u00e4hrungsplan erstellt',
      bullet2: 'Nach Kategorien mit Mengenangaben sortiert',
      bullet3: 'PDF-Export & Smart-Modus f\u00fcr Schweizer H\u00e4ndler',
    },

    recipes: {
      title: 'Detaillierte Rezepte nur f\u00fcr VIP',
      description:
        'VIP-Mitglieder erhalten professionelle Schritt-f\u00fcr-Schritt-Rezepte, die direkt mit ihrem personalisierten 30-Tage-Plan verkn\u00fcpft sind.',
      bullet1: 'Vollst\u00e4ndige Zutatenlisten mit genauen Mengenangaben',
      bullet2: 'Professionelle Schritt-f\u00fcr-Schritt-Anleitung',
      bullet3: 'Gefiltert nach deinen Allergien und Vorlieben',
    },

    pdfExport: {
      title: 'PDF-Export nur f\u00fcr VIP',
      description:
        'Lade deinen vollst\u00e4ndigen 30-Tage-Ern\u00e4hrungsplan, Rezepte und Einkaufsliste als ansprechend formatiertes PDF herunter.',
      bullet1: 'Vollst\u00e4ndiger 30-Tage-Plan in einem Dokument',
      bullet2: 'Inklusive Rezepte und Einkaufsliste',
      bullet3: 'Allergenhinweise und t\u00e4gliche Kaloriens\u00fcbersicht',
    },

    modifyPlan: {
      title: 'Plananpassungen nur f\u00fcr VIP',
      description:
        'VIP-Mitglieder k\u00f6nnen jederzeit einzelne Mahlzeiten oder ganze Tage \u00fcber NutriBot anpassen, tauschen oder neu generieren lassen.',
      bullet1: 'Einzelne Mahlzeiten oder ganze Tage tauschen',
      bullet2: 'Kalorien, Makros und Di\u00e4ttyp anpassen',
      bullet3: 'Unbegrenzte Planversionen, sofort aktualisiert',
    },
  },
};

export default vip;